import { render } from "./GameReviewsPage.vue?vue&type=template&id=1004d9a8&scoped=true"
import script from "./GameReviewsPage.vue?vue&type=script&lang=js"
export * from "./GameReviewsPage.vue?vue&type=script&lang=js"

import "./GameReviewsPage.vue?vue&type=style&index=0&id=1004d9a8&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1004d9a8"]])

export default __exports__